// eslint-disable-next-line import/prefer-default-export
export const getAuthors = (book) => book.authors || [];

const transformOrNull = (value, transformer) => {
  // eslint-disable-next-line no-restricted-globals
  if (value === null || value === undefined || isNaN(value)) {
    return null;
  }

  return transformer(value);
};

const intOrNull = (value) => transformOrNull(
  value,
  (val) => parseInt(val, 10),
);

const floatOrNull = (value) => transformOrNull(
  value,
  parseFloat,
);

/**
 * Because we cannot properly trust that the back-end correctly
 * formats numbers and string, do we use this middleware to ensure that
 * they are correct.
 *
 * @param {object} book
 * */
export const ensureProperFormat = (book) => {
  const validBook = {};

  validBook.id = book.id;
  validBook.title = book.title;
  validBook.isbn = intOrNull(book.isbn);
  validBook.edition = intOrNull(book.edition);
  validBook.image = book.image;
  validBook.imageUrl = book.image_url;
  validBook.binding = book.binding;
  validBook.publisher = book.publisher;
  validBook.authors = book.authors;
  validBook.lastUpdated = book.last_updated;
  validBook.popularity = floatOrNull(book.popularity);
  validBook.publishedYear = floatOrNull(book.published_year);

  return validBook;
};

export const getBookUrlFromDOM = (bookId) => {
  const bookWrapper = document.getElementById(`book-${bookId}`);

  if (!bookWrapper) {
    return null;
  }

  const [bookCover] = bookWrapper.getElementsByClassName('book-cover');

  if (!bookCover) {
    return null;
  }

  // Book-cover has <img/> as child
  return bookCover.children[0].src;
};
